export interface AffiliateCodeUniqueMasterCodePayloadModel {
  code: string;
}
